import {
  UpdateStressCheckData,
  ActionType,
} from "models/stressCheck/updateStressCheck";
import { IResponse } from "models";

export const updateStressCheckAction = (payload: UpdateStressCheckData) => {
  return {
    type: ActionType.UPDATE_STRESS_CHECK,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.UPDATE_STRESS_CHECK_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IResponse) => {
  return {
    type: ActionType.UPDATE_STRESS_CHECK_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.RESET_UPDATE_STRESS_CHECK,
  };
};
